import './style.scss'
import React, { useEffect, useRef, useState } from 'react'

export interface ActionMenuItem {
    label: string
    onClick: () => void
    variant?: 'default' | 'danger'
}

export interface ActionMenuProps {
    items: ActionMenuItem[]
    className?: string
}

export const ActionMenu: React.FC<ActionMenuProps> = ({ items, className = '' }) => {
    const [open, setOpen] = useState(false)
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const onClickOutside = (e: MouseEvent) => {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false)
        }
        document.addEventListener('mousedown', onClickOutside)
        return () => document.removeEventListener('mousedown', onClickOutside)
    }, [])

    return (
        <div className={`action-menu ${className}`} ref={ref}>
            <button
                type="button"
                className="action-menu__trigger"
                aria-label="Open menu"
                onClick={() => setOpen((v) => !v)}
            >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <circle cx="9" cy="4" r="1.4" fill="currentColor" />
                    <circle cx="9" cy="9" r="1.4" fill="currentColor" />
                    <circle cx="9" cy="14" r="1.4" fill="currentColor" />
                </svg>
            </button>

            {open && (
                <div className="action-menu__panel">
                    {items.map((item) => (
                        <button
                            key={item.label}
                            type="button"
                            className={`action-menu__item ${item.variant === 'danger' ? 'action-menu__item--danger' : ''}`}
                            onClick={() => {
                                setOpen(false)
                                item.onClick()
                            }}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}

export default ActionMenu